import React, { useState, useEffect } from 'react'
import Layout from '../components/Layout'
import AnalyticsOverview from '../components/AnalyticsOverview'
import api from '../services/api'

export default function ReportPage() {
  const [divisionStats, setDivisionStats] = useState([])
  const [stats, setStats] = useState({})
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [exporting, setExporting] = useState('')
  const [exportError, setExportError] = useState('')

  useEffect(() => {
    let active = true
    Promise.all([api.get('/contracts/dashboard'), api.get('/contracts/division-stats')])
      .then(([dashboard, divisions]) => {
        if (!active) return
        if (!dashboard.data.success || !divisions.data.success) throw new Error('โหลดข้อมูลรายงานไม่สำเร็จ')
        setStats(dashboard.data.stats || {})
        setDivisionStats(divisions.data.data || [])
      })
      .catch(() => { if (active) setError('โหลดข้อมูลรายงานไม่สำเร็จ กรุณาลองใหม่') })
      .finally(() => { if (active) setLoading(false) })
    return () => { active = false }
  }, [])

  const handleExport = async (url, filename) => {
    setExporting(url)
    setExportError('')
    try {
      const res = await api.get(url, { responseType: 'blob' })
      if (!String(res.headers['content-type']).includes('spreadsheetml.sheet')) throw new Error('ระบบไม่ได้ส่งไฟล์ Excel กลับมา')
      const blobUrl = window.URL.createObjectURL(new Blob([res.data]))
      const link = document.createElement('a')
      link.href = blobUrl
      link.download = filename
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.setTimeout(() => window.URL.revokeObjectURL(blobUrl), 1000)
    } catch (err) {
      let message = err.message || 'ไม่สามารถส่งออกไฟล์ได้'
      try { if (err.response?.data instanceof Blob) message = (JSON.parse(await err.response.data.text())).message || message } catch (_) { /* use the safe fallback */ }
      setExportError(message)
    } finally { setExporting('') }
  }

  return <Layout><div className="a-report-page">
    <header className="a-page-hero">
      <div><h1>รายงานสถิติ</h1><p>ภาพรวมสัญญาจ้างพนักงานแยกตามกองงาน</p></div>
      <div className="a-hero-actions">
        <button type="button" className="a-export-secondary" disabled={!!exporting}
          onClick={() => handleExport('/contracts/export', `contracts_${new Date().toISOString().slice(0, 10)}.xlsx`)}>
          <i className="ti ti-download" /> {exporting === '/contracts/export' ? 'กำลังส่งออก…' : 'ส่งออกสัญญา'}
        </button>
        <button type="button" className="a-export-primary" disabled={!!exporting}
          onClick={() => handleExport('/employees/export', `employees_${new Date().toISOString().slice(0, 10)}.xlsx`)}>
          <i className="ti ti-download" /> {exporting === '/employees/export' ? 'กำลังส่งออก…' : 'ส่งออกพนักงาน'}
        </button>
      </div>
    </header>
    {exportError && <p className="a-export-error" role="alert">ส่งออกไฟล์ไม่สำเร็จ: {exportError}</p>}
    <AnalyticsOverview stats={stats} divisionStats={divisionStats} loading={loading} error={error} />
  </div></Layout>
}
